import { axiosWithConfig } from '@assembly/config/axios'

export const getPublicCandidateProfile = async (candidateId: string, jobId?: string) => {
    const url = jobId
        ? `/recruiting/candidate/public/${candidateId}?jid=${jobId}`
        : `/recruiting/candidate/public/${candidateId}`

    return axiosWithConfig.get(url)
}

export const contactCandidate = async (candidateId: string, payload: any) => {
    return axiosWithConfig.post(`/recruiting/candidate/public/${candidateId}/contact`, payload, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    })
} 